export default __webpack_public_path__ + "static/media/Gosebrink.6ad26af5.png";